import React from 'react'
import {get} from 'lodash'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import {WithContext as ReactTags} from 'react-tag-input'
import styled from 'styled-components'
import {Query, Mutation} from 'react-apollo'
import {GET_FAQ, GET_FAQ_TRAIN_JOB_OPERATION} from '../../../../../../graphql/query'
import {UPDATE_FAQ, TRAIN_FAQ} from '../../../../../../graphql/mutation'
import {uploadFile} from '../../../../../../functions/project'

import AnswerItemList from './AnswerItemList'

const JOB_STATUS_PROCESSING = 'PROCESSING'

const KeyCodes = {
  enter: 13,
}

const TableCellWithStyle = styled(TableCell)`
  padding: 5px;
`

const delimiters = [KeyCodes.enter]
const removeTypename = value => {
  if (value === null || value === undefined) {
    return value
  }
  if (Array.isArray(value)) {
    return value.map(v => removeTypename(v))
  }
  if (typeof value === 'object') {
    const newObj = {}
    Object.entries(value).forEach(([key, v]) => {
      if (key !== '__typename') {
        newObj[key] = removeTypename(v)
      }
    })
    return newObj
  }
  return value
}
const validateFaqData = faq => {
  if (!faq.name || faq.questions.length === 0 || faq.response.length === 0) {
    return false
  }
  return true
}
class FAQSection extends React.Component {
  state = {
    faqData: null,
  }

  constructor(props) {
    super(props)
    const dataProps = [...props.faqData]
    this.state = {
      faqData: removeTypename(dataProps),
      loading: false,
    }
  }

  onNameChange(faqIndex, name) {
    const newState = {...this.state}
    newState.faqData[faqIndex].name = name
    this.setState({
      faqData: newState.faqData,
    })
  }

  onAddQuestion(faqIndex, tag) {
    const newState = {...this.state}
    newState.faqData[faqIndex].questions.push(tag.text)
    this.setState({
      faqData: newState.faqData,
    })
  }

  onAddResponse(faqIndex, response) {
    const newState = {...this.state}
    newState.faqData[faqIndex].response.push({
      type: response.type,
      value: response.value,
      image: response.image,
    })
    this.setState({
      faqData: newState.faqData,
    })
  }

  onDeleteQuestion(faqIndex, tagIndex) {
    const newState = {...this.state}
    newState.faqData[faqIndex].questions.splice(tagIndex, 1)
    this.setState({
      faqData: newState.faqData,
    })
  }

  onDeleteResponse(faqIndex, tagIndex) {
    const newState = {...this.state}
    newState.faqData[faqIndex].response.splice(tagIndex, 1)
    this.setState({
      faqData: newState.faqData,
    })
  }

  onAddMoreClicked = () => {
    this.setState({
      faqData: [...this.state.faqData, {name: '', questions: [], response: []}],
    })
  }

  onRemoveItem = faqIndex => {
    const newState = {...this.state}
    newState.faqData.splice(faqIndex, 1)
    this.setState({
      faqData: newState.faqData,
    })
  }

  onSave = async updateFaq => {
    const {projectId} = this.props
    this.setState({loading: true})
    const newFAQsState = this.state.faqData.filter(o => validateFaqData(o))
    const FAQsResponseWithImage = await this.uploadFiles(newFAQsState)
    await updateFaq({
      variables: {
        projectId,
        faq: FAQsResponseWithImage,
      },
    })
    this.setState({
      faqData: newFAQsState,
    })
    alert('Saved')
    this.setState({loading: false})
  }

  onTrain = async updateFaq => {
    const {projectId} = this.props
    await updateFaq({
      variables: {
        projectId,
      },
    })
  }

  /**
   * FAQsAndResponses
   [{
      "name": "question name",
      "questions": ["some question?"],
      "response": [{"type": "text", "value": "YOYO"}]
   }]
   */
  uploadFiles = async FAQsAndResponses => {
    const {projectId} = this.props

    const promises = []
    const images = []

    for (let i = 0; i < FAQsAndResponses.length; i++) {
      const {response: responses} = FAQsAndResponses[i]

      for (let j = 0; j < responses.length; j++) {
        const response = responses[j]
        const {image, type} = response
        if (image && image.file && type === 'image') {
          promises.push(
            new Promise(async (resolve, _reject) => {
              const result = await uploadFile(projectId, image.file)
              if (!images[i]) {
                images[i] = []
              }
              images[i][j] = result.data.publicUrl
              resolve()
            }),
          )
        }
      }
    }

    await Promise.all(promises)

    // update FAQs response with uploaded image url
    FAQsAndResponses = FAQsAndResponses.map((FAQs, questionIndex) => {
      const {response: responses} = FAQs
      const responsesWithImage = responses.map((response, responseIndex) => {
        const imageOnQuestionIndex = images[questionIndex] ? images[questionIndex] : []
        const image = imageOnQuestionIndex[responseIndex]
        const {type} = response
        const value = image || response.value
        return {type, value}
      })
      return {...FAQs, response: responsesWithImage}
    })

    return FAQsAndResponses
  }

  render() {
    const {faqData, loading} = this.state
    const {projectId} = this.props
    return (
      <div>
        <div>
          <Table padding="none">
            <TableHead>
              <TableRow>
                <TableCell style={{width: '2%', padding: '5px'}} align="left">
                  No.
                </TableCell>
                <TableCell style={{width: '5%', padding: '5px'}} align="left">
                  Name
                </TableCell>
                <TableCell
                  style={{width: '43%', padding: '5px'}}
                  align="center"
                >
                  Question
                </TableCell>
                <TableCell
                  style={{width: '45%', padding: '5px'}}
                  align="center"
                >
                  Answer
                </TableCell>
                <TableCell style={{width: '5%', padding: '5px'}} align="center">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{this.generateFAQsList(faqData, projectId)}</TableBody>
          </Table>
        </div>
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
          <Button
            style={{margin: '5px'}}
            variant="contained"
            color="primary"
            onClick={this.onAddMoreClicked}
          >
            Add more
          </Button>
          <Mutation
            mutation={UPDATE_FAQ}
            refetchQueries={[
              {
                query: GET_FAQ,
                variables: {
                  projectId,
                },
              },
            ]}
          >
            {(updateFaq, {_loading, error}) => {
              if (error) return 'Error'
              return (
                <Button
                  onClick={() => this.onSave(updateFaq)}
                  style={{margin: '5px'}}
                  variant="contained"
                  color="secondary"
                  disabled={loading}
                >
                  Save
                  {loading ? <CircularProgress size={30} style={{marginLeft: '10px', width: '30px', height: '30px'}} /> : null}
                </Button>
              )
            }}
          </Mutation>
          <Query query={GET_FAQ_TRAIN_JOB_OPERATION} variables={{projectId}}>
            {({data, startPolling, stopPolling}) => {
              const jobStatus = get(data, 'faqTrainJobOperation.status', '')
              const isJobProcessing = jobStatus === JOB_STATUS_PROCESSING
              if (jobStatus === JOB_STATUS_PROCESSING) {
                startPolling(2500)
              } else {
                stopPolling()
              }

              return (
                <Mutation
                  mutation={TRAIN_FAQ}
                  refetchQueries={[
                    {
                      query: GET_FAQ_TRAIN_JOB_OPERATION,
                      variables: {
                        projectId,
                      },
                    },
                  ]}
                >
                  {(trainFAQ, {_loading, error}) => {
                    if (error) return 'Error'
                    return (
                      <Button
                        onClick={() => this.onTrain(trainFAQ)}
                        style={{margin: '5px'}}
                        variant="contained"
                        color="secondary"
                        disabled={isJobProcessing}
                      >
                        {isJobProcessing ? 'Training' : 'Train'}
                        {isJobProcessing ? <CircularProgress size={30} style={{marginLeft: '10px', width: '30px', height: '30px'}} /> : null}
                      </Button>
                    )
                  }}
                </Mutation>
              )
            }}
          </Query>
        </div>
      </div>
    )
  }

  generateFAQsList(list, projectId) {
    return list.map((item, index) => {
      return (
        <TableRow key={index} style={{verticalAlign: 'top'}}>
          <TableCellWithStyle align="left">{index + 1}</TableCellWithStyle>
          <TableCellWithStyle align="left">
            <TextField
              onChange={event => {
                this.onNameChange(index, event.target.value)
              }}
              value={item.name}
            />
          </TableCellWithStyle>
          <TableCellWithStyle align="left">
            <ReactTags
              tags={item.questions.map(q => ({id: q, text: q}))}
              handleDelete={tagIndex => {
                this.onDeleteQuestion(index, tagIndex)
              }}
              handleAddition={tag => {
                this.onAddQuestion(index, tag)
              }}
              delimiters={delimiters}
            />
          </TableCellWithStyle>
          <TableCellWithStyle align="left">
            <AnswerItemList
              key={item.name}
              projectId={projectId}
              responseMessage={item.response}
              onDeleteResponse={response => {
                this.onDeleteResponse(index, response)
              }}
              onAddResponse={response => {
                this.onAddResponse(index, response)
              }}
            />
          </TableCellWithStyle>
          <TableCellWithStyle align="left">
            <Button
              onClick={() => {
                this.onRemoveItem(index)
              }}
              variant="contained"
              color="secondary"
            >
              Remove
            </Button>
          </TableCellWithStyle>
        </TableRow>
      )
    })
  }
}

export default ({projectId}) => (
  <Query query={GET_FAQ} variables={{projectId}}>
    {({data, loading, error}) => {
      if (loading) return 'Loading'
      if (error) return 'Error'
      return <FAQSection faqData={data.getFAQ} projectId={projectId} />
    }}
  </Query>
)



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/aiSetting/faq/index.js